
export const getAssetVideoUrl = filename =>
  process.env.PUBLIC_URL + '/assets/video/' + filename

export const getAssetImagesUrl = filename =>
  process.env.PUBLIC_URL + '/assets/images/' + filename

export const getAssetShaderUrl = filename =>
  process.env.PUBLIC_URL + '/assets/shaders/' + filename

export const getAssetModelUrl = filename =>
  process.env.PUBLIC_URL + '/assets/models/' + filename

export const getAssetData = filename =>
  process.env.PUBLIC_URL + '/assets/data/' + filename


export const getErrorMessage = error => {
  let errorMessage
  if (error) {
    errorMessage = [error.message]
    if (error.code) {
      errorMessage.unshift(error.code)
    }
    if (error.response) {
      const response = error.response
      if (response.config && response.config.url) {
        const url = '/' + response.config.url
        errorMessage.unshift(url)
      }
      if (response.data && response.data.Message) {
        const message = response.data.Message
        errorMessage.push(message)
      }
      if (response.data && response.data.ExceptionMessage) {
        const exceptionMessage = response.data.ExceptionMessage
        errorMessage.push(exceptionMessage)
      }
      if (response.data && response.data._ResponseMessage) {
        const responseMessage = response.data._ResponseMessage
        errorMessage.push(responseMessage)
      }
    }
    errorMessage = errorMessage.join(' ')
  }
  else {
    errorMessage = 'Unknown error'
  }
  return errorMessage
}
